import React from 'react'
import PropTypes from 'prop-types'

import {Box} from '@chakra-ui/react'

import {LogoHorizontal, ThemeProvider, Payment} from '../../components'
import PaymentSuccess from './PaymentSuccess'
import InvoiceSummary from './InvoiceSummary'
import {useAuthenticityToken} from '../../hooks/authenticityToken'
import {
  retrieveInvoicePaymentInfo,
  retrieveInvoicePointsInfo,
} from '../../../api'

const CustomerPaymentScreen = ({xeroInvoiceUUID, authenticityToken}) => {
  const [paymentInformation, setPaymentInformation] = React.useState({})
  const [pointsInformation, setPointsInformation] = React.useState({
    coins: 0,
    redemptionOptions: [],
  })

  const {authenticityToken: token} = useAuthenticityToken(authenticityToken)
  const [displaySuccessPayment, setDisplaySuccessPayment] =
    React.useState(false)

  // Needs for show the invoice data.
  React.useEffect(() => {
    if (xeroInvoiceUUID) {
      retrieveInvoicePointsInfo({xeroInvoiceUUID}).then((data) => {
        setPointsInformation(data)
      })
    }
  }, [xeroInvoiceUUID])

  React.useEffect(() => {
    if (xeroInvoiceUUID) {
      retrieveInvoicePaymentInfo({xeroInvoiceUUID}).then((data) => {
        setPaymentInformation(data)
      })
    }
  }, [xeroInvoiceUUID])

  const {invoice} = paymentInformation

  const onSuccessCC = () => {
    setDisplaySuccessPayment(true)
  }

  return (
    <ThemeProvider>
      <Box
        width="100%"
        backgroundColor="mld.neutral.800"
        minHeight="100vh"
        px="sm"
        py="lg"
      >
        <Box
          py="lg"
          px={{base: 'md', sm: 'lg'}}
          backgroundColor="neutral.white"
          maxWidth="lg"
          margin="0 auto"
          borderRadius="lg"
          boxShadow="0px 2px 4px rgba(23, 27, 30, 0.1)"
        >
          <LogoHorizontal width={295} height={34} />
          {displaySuccessPayment ? (
            <PaymentSuccess
              coins={pointsInformation.coins}
              redemptionOptions={pointsInformation.redemptionOptions}
            />
          ) : (
            <>
              {invoice && (
                <InvoiceSummary
                  points={{
                    coins: pointsInformation.coins,
                    redemptionOptions: pointsInformation.redemptionOptions,
                  }}
                  invoice={{
                    id: invoice.id,
                    xeroInvoiceId: invoice.xeroInvoiceId,
                    number: invoice.number,
                    amount: invoice.amount,
                    dueAmount: invoice.dueAmount,
                    appliedCreditNoteAmount: invoice.appliedCreditNoteAmount,
                    invoicePaymentsAmount: invoice.invoicePaymentsAmount,
                    supplierName: invoice.supplierName,
                    dueDate: invoice.formattedDueDate,
                    dueInDays: invoice.dueInDays,
                    isPaid: invoice.isPaid,
                    isVoided: invoice.isVoided,
                    pdfAvailable: invoice.pdfAvailable,
                  }}
                />
              )}
              <Payment
                onSuccessCC={onSuccessCC}
                xeroInvoiceUUID={xeroInvoiceUUID}
                authenticityToken={token}
              />
            </>
          )}
        </Box>
      </Box>
    </ThemeProvider>
  )
}

CustomerPaymentScreen.propTypes = {
  xeroInvoiceUUID: PropTypes.string.isRequired,
  authenticityToken: PropTypes.string.isRequired,
}

export default CustomerPaymentScreen
